import { render, staticRenderFns } from "./CellEditor.vue?vue&type=template&id=5584c7fc&scoped=true&"
import script from "./CellEditor.vue?vue&type=script&lang=js&"
export * from "./CellEditor.vue?vue&type=script&lang=js&"
import style0 from "./CellEditor.vue?vue&type=style&index=0&id=5584c7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5584c7fc",
  null
  
)

export default component.exports